
















import { Component, mixins } from 'nuxt-property-decorator';

import BravadoText from '@/components/common/BravadoText/BravadoText.vue';

import HeaderMenuConnectionsCard from '@/components/global/HeaderMenu/HeaderMenuConnections/HeaderMenuConnectionsCard.vue';

import HeaderMenuConnectionsMixin from '@/components/global/HeaderMenu/HeaderMenuConnections/HeaderMenuConnectionsMixin';

@Component<HeaderMenuConnections>({
  name: 'HeaderMenuConnections',
  components: {
    BravadoText,
    HeaderMenuConnectionsCard,
  },
})
export default class HeaderMenuConnections extends mixins(HeaderMenuConnectionsMixin) {}
